import { render, staticRenderFns } from "./CookiesAdd.vue?vue&type=template&id=a87f83ca&scoped=true&"
import script from "./CookiesAdd.vue?vue&type=script&lang=js&"
export * from "./CookiesAdd.vue?vue&type=script&lang=js&"
import style0 from "./CookiesAdd.vue?vue&type=style&index=0&id=a87f83ca&prod&lang=css&"
import style1 from "./CookiesAdd.vue?vue&type=style&index=1&id=a87f83ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87f83ca",
  null
  
)

export default component.exports